import { render } from "./RodapePedido.vue?vue&type=template&id=c0e43118&scoped=true"
import script from "./RodapePedido.vue?vue&type=script&lang=js"
export * from "./RodapePedido.vue?vue&type=script&lang=js"

import "./RodapePedido.vue?vue&type=style&index=0&id=c0e43118&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0e43118"]])

export default __exports__